// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs_wrapper[data-v-101d086e]{padding:0 15px;position:relative;height:100%}.tabs_wrapper .add_btn[data-v-101d086e]{position:absolute;right:15px;top:5px;z-index:22}.tree_wrapper[data-v-101d086e]{overflow:auto}", ""]);
// Exports
module.exports = exports;
